import React from 'react';
import { injectScript } from '../../helpers';

class PublisherdeskProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      context: {},
    };
    this.abortIdle = null;
  }

  componentDidMount() {
    if (window && window.requestIdleCallback) {
      const idleHandler = window.requestIdleCallback(this.init.bind(this), {
        timeout: 10000,
      });
      this.abortIdle = () => {
        window.cancelIdleCallback(idleHandler);
        this.abortIdle = null;
      };
    } else {
      this.init();
    }
  }

  init() {
    Promise.all([
      injectScript(this.props.config.publisherdeskLib),
      injectScript(this.props.config.doubleclickLib),
    ])
      .then(() => {
        this.pushGoogleTagData();
      })
      .catch(() => {});
  }

  componentDidUpdate() {
    this.pushGoogleTagData();
  }

  render() {
    const BaseProvider = this.props.baseProvider;
    return (
      <BaseProvider value={this.state.context}>
        {this.props.children}
      </BaseProvider>
    );
  }

  pushGoogleTagData() {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(() => {
      window.googletag
        .pubads()
        .setTargeting('PostID', [`${this.props.adContext.state?.product?.id}`]);
      window.googletag
        .pubads()
        .setTargeting('Page-Type', [this.props.adContext.state.pageType]);
      window.googletag
        .pubads()
        .setTargeting('Brand', [this.props.adContext.state?.brand?.name]);
      window.googletag
        .pubads()
        .setTargeting('Model', [this.props.adContext.state?.product?.name]);
      window.googletag
        .pubads()
        .setTargeting('Category', [
          this.props.adContext.state?.product?.category?.name,
        ]);
    });
  }
}

export default PublisherdeskProvider;
